var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWsB2BIconUpcomingGry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.68,
    height: 137.13,
    viewBox: "0 0 120.68 137.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.88,44.35a62.18,62.18,0,0,1,24.73,18.94l3.93-3.08a67.15,67.15,0,0,0-26.71-20.47ZM98.07,39.76a62.27,62.27,0,0,1,30.81,4.59l2-4.61a67.25,67.25,0,0,0-33.28-5ZM68.9,50.69A62.2,62.2,0,0,1,98.07,39.76l-.52-5A67.29,67.29,0,0,0,66,46.59ZM48.68,74.38A62.27,62.27,0,0,1,68.9,50.69L66,46.59a67.33,67.33,0,0,0-21.84,25.6Zm-6.2,30.53a62.31,62.31,0,0,1,6.2-30.53l-4.49-2.19a67.27,67.27,0,0,0-6.7,33Zm9.38,29.7a62.21,62.21,0,0,1-9.38-29.7l-5,.26a67.12,67.12,0,0,0,10.13,32.09Zm22.59,21.44a62.1,62.1,0,0,1-22.59-21.44l-4.24,2.65A67.1,67.1,0,0,0,72,160.42Zm30.15,7.8a62.13,62.13,0,0,1-30.15-7.8L72,160.42a67.12,67.12,0,0,0,32.57,8.43Zm49-100.56a2.5,2.5,0,1,0,3.93-3.08Zm-49,105.56a2.5,2.5,0,0,0,0-5Z",
    transform: "translate(-37.4 -31.72)",
    fill: "#bbbaba",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.08,62V34.22h-5V62Zm-27.16,2.49h24.66v-5H130.92Zm27.16-30.24a2.5,2.5,0,0,0-5,0ZM155.58,62v2.5a2.51,2.51,0,0,0,2.5-2.5Zm-24.66-2.51a2.5,2.5,0,0,0,0,5Z",
    transform: "translate(-37.4 -31.72)",
    fill: "#bbbaba",
    opacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.72,108.24V62h-5v46.28Zm31.87,23-32.86-24.95-3,4,32.87,24.94ZM101.72,62a2.5,2.5,0,0,0-5,0Zm-2.5,46.28h-2.5a2.52,2.52,0,0,0,1,2Zm31.35,26.94a2.5,2.5,0,0,0,3-4Z",
    transform: "translate(-37.4 -31.72)",
    fill: "#bbbaba",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWsB2BIconUpcomingGry);
export default __webpack_public_path__ + "static/media/ws-b2b-icon-upcoming-gry.8802a4e2599a4565b3fc6c27bc1ca310.svg";
export { ForwardRef as ReactComponent };